import { useState, type InputHTMLAttributes } from "react";
import { Eye, EyeOff } from "lucide-react";

/** A password input with a show/hide toggle — reveals whatever is currently
 * typed into the field, not some pre-existing secret (passwords are stored
 * as a one-way hash and can't be retrieved). */
export function PasswordField({ value, onChange, className, ...rest }: {
  value: string;
  onChange: (value: string) => void;
  className: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange" | "type" | "className">) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        {...rest}
        type={visible ? "text" : "password"}
        value={value}
        onChange={e => onChange(e.target.value)}
        className={`${className} pr-9`}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-ink-3 hover:text-ink"
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
